/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { OrderDirection } from '../models/order-direction';
import { ProductStockAlertDto } from '../models/product-stock-alert-dto';
import { ProductStockAlertDtoDlmBaseResponse } from '../models/product-stock-alert-dto-dlm-base-response';
import { ProductStockAlertDtoListDlmBaseResponse } from '../models/product-stock-alert-dto-list-dlm-base-response';
import { ProductStockAlertDtoPagedResponseDlmBaseResponse } from '../models/product-stock-alert-dto-paged-response-dlm-base-response';
import { PropertyFilter } from '../models/property-filter';

@Injectable({
  providedIn: 'root',
})
export class ProductStockAlertService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiProductStockAlertGetAlertsGet
   */
  static readonly ApiProductStockAlertGetAlertsGetPath = '/api/ProductStockAlert/get-alerts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertGetAlertsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetAlertsGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<ProductStockAlertDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertGetAlertsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductStockAlertDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertGetAlertsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetAlertsGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<ProductStockAlertDtoListDlmBaseResponse> {

    return this.apiProductStockAlertGetAlertsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ProductStockAlertDtoListDlmBaseResponse>) => r.body as ProductStockAlertDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertGetAlertsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetAlertsGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<ProductStockAlertDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertGetAlertsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductStockAlertDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertGetAlertsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetAlertsGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<ProductStockAlertDtoListDlmBaseResponse> {

    return this.apiProductStockAlertGetAlertsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProductStockAlertDtoListDlmBaseResponse>) => r.body as ProductStockAlertDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiProductStockAlertGetPaginatedAlertsGet
   */
  static readonly ApiProductStockAlertGetPaginatedAlertsGetPath = '/api/ProductStockAlert/get-paginated-alerts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertGetPaginatedAlertsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetPaginatedAlertsGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertGetPaginatedAlertsGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertGetPaginatedAlertsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetPaginatedAlertsGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<ProductStockAlertDtoPagedResponseDlmBaseResponse> {

    return this.apiProductStockAlertGetPaginatedAlertsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>) => r.body as ProductStockAlertDtoPagedResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertGetPaginatedAlertsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetPaginatedAlertsGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertGetPaginatedAlertsGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertGetPaginatedAlertsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetPaginatedAlertsGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<ProductStockAlertDtoPagedResponseDlmBaseResponse> {

    return this.apiProductStockAlertGetPaginatedAlertsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>) => r.body as ProductStockAlertDtoPagedResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiProductStockAlertGetPaginatedOverridesGet
   */
  static readonly ApiProductStockAlertGetPaginatedOverridesGetPath = '/api/ProductStockAlert/get-paginated-overrides';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertGetPaginatedOverridesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetPaginatedOverridesGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertGetPaginatedOverridesGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertGetPaginatedOverridesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetPaginatedOverridesGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<ProductStockAlertDtoPagedResponseDlmBaseResponse> {

    return this.apiProductStockAlertGetPaginatedOverridesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>) => r.body as ProductStockAlertDtoPagedResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertGetPaginatedOverridesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetPaginatedOverridesGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertGetPaginatedOverridesGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertGetPaginatedOverridesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertGetPaginatedOverridesGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<ProductStockAlertDtoPagedResponseDlmBaseResponse> {

    return this.apiProductStockAlertGetPaginatedOverridesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProductStockAlertDtoPagedResponseDlmBaseResponse>) => r.body as ProductStockAlertDtoPagedResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiProductStockAlertAddAlertPost
   */
  static readonly ApiProductStockAlertAddAlertPostPath = '/api/ProductStockAlert/add-alert';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertAddAlertPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductStockAlertAddAlertPost$Plain$Response(params?: {
    body?: ProductStockAlertDto
  }): Observable<StrictHttpResponse<ProductStockAlertDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertAddAlertPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductStockAlertDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertAddAlertPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductStockAlertAddAlertPost$Plain(params?: {
    body?: ProductStockAlertDto
  }): Observable<ProductStockAlertDtoDlmBaseResponse> {

    return this.apiProductStockAlertAddAlertPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ProductStockAlertDtoDlmBaseResponse>) => r.body as ProductStockAlertDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertAddAlertPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductStockAlertAddAlertPost$Json$Response(params?: {
    body?: ProductStockAlertDto
  }): Observable<StrictHttpResponse<ProductStockAlertDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertAddAlertPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductStockAlertDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertAddAlertPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductStockAlertAddAlertPost$Json(params?: {
    body?: ProductStockAlertDto
  }): Observable<ProductStockAlertDtoDlmBaseResponse> {

    return this.apiProductStockAlertAddAlertPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProductStockAlertDtoDlmBaseResponse>) => r.body as ProductStockAlertDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiProductStockAlertEditAlertPut
   */
  static readonly ApiProductStockAlertEditAlertPutPath = '/api/ProductStockAlert/edit-alert';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertEditAlertPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductStockAlertEditAlertPut$Plain$Response(params?: {
    body?: ProductStockAlertDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertEditAlertPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertEditAlertPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductStockAlertEditAlertPut$Plain(params?: {
    body?: ProductStockAlertDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiProductStockAlertEditAlertPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertEditAlertPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductStockAlertEditAlertPut$Json$Response(params?: {
    body?: ProductStockAlertDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertEditAlertPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertEditAlertPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductStockAlertEditAlertPut$Json(params?: {
    body?: ProductStockAlertDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiProductStockAlertEditAlertPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiProductStockAlertArchiveAlertPut
   */
  static readonly ApiProductStockAlertArchiveAlertPutPath = '/api/ProductStockAlert/archive-alert';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertArchiveAlertPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertArchiveAlertPut$Plain$Response(params?: {
    productStockAlertId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertArchiveAlertPutPath, 'put');
    if (params) {
      rb.query('productStockAlertId', params.productStockAlertId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertArchiveAlertPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertArchiveAlertPut$Plain(params?: {
    productStockAlertId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiProductStockAlertArchiveAlertPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductStockAlertArchiveAlertPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertArchiveAlertPut$Json$Response(params?: {
    productStockAlertId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductStockAlertService.ApiProductStockAlertArchiveAlertPutPath, 'put');
    if (params) {
      rb.query('productStockAlertId', params.productStockAlertId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductStockAlertArchiveAlertPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductStockAlertArchiveAlertPut$Json(params?: {
    productStockAlertId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiProductStockAlertArchiveAlertPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

}
